import React, { use } from "react";
import useAdminSMS from "../hooks/useAdminSMS";
import AdminSMS from "../components/AdminSMS";

const { sendSMS = null } = useAdminSMS;

export default function AdminSMSInterface(props) {
  const { onCancelAction, currentItem, callback, canEdit, onSave } = props;

  return (
    <React.Fragment>
      <AdminSMS
        sendSMS={sendSMS}
        onCancelAction={onCancelAction}
        currentItem={currentItem}
        callback={callback}
        canEdit={canEdit}
        onSave={onSave}
      />
    </React.Fragment>
  );
}
